import { render, staticRenderFns } from "./ProductDetailTab.vue?vue&type=template&id=cfd49db6"
import script from "./ProductDetailTab.vue?vue&type=script&lang=js"
export * from "./ProductDetailTab.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailTab.vue?vue&type=style&index=0&id=cfd49db6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports